import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useStaffCardWardrobeList = () => {
  return useQuery({
    queryKey: ["staffCardWardrobeListState"],
    queryFn: async () =>
      callApi({
        path: "wardrobelist",
        command: "",
        data: JSON.stringify({ list: {} }),
      }),
    staleTime: 5000,
  });
};
